// extracted by mini-css-extract-plugin
export default {"services":"services_services__NCrhV"};